module.exports = __webpack_public_path__ + "static/media/vaccination_schedule.0d1fdf98.csv";